export default __webpack_public_path__ + "static/media/logo-text-blue.afec4143.svg";